module.exports = __webpack_public_path__ + "img/icons8-google.81ad048e.svg";